var data = require('../data.json');
var createBaseTree = require('./base-tree.js');

function createPrebuiltTree () {
  return createBaseTree().fromJSON(data);
}

module.exports = createPrebuiltTree;



//////////////////
// WEBPACK FOOTER
// ./node_modules/which-country/lib/prebuilt-tree.js
// module id = 987
// module chunks = 0